<template>
  <span v-if="!disabled">
    <template v-if="value.toLowerCase() == 'updating'">
      <img src="/img/Spinner-1s-30px.gif" />
    </template>
    <template v-else>
      <span :title="'Dehumidifier: ' + value">
        <v-icon
          :size="iconSize"
          :color="dehumstateColors[value.toLowerCase()]"
          >$vuetify.icons.dehumidifier</v-icon
        >
      </span>
    </template>
  </span>
  <span v-else>
    <span title="No Dehumidifier Available">
      <v-icon color="rgba(128,128,128,0.3)" :size="iconSize"
        >$vuetify.icons.dehumidifier</v-icon
      >
    </span>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "disabled", "iconSize"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {
      dehumstateColors: {
        off: "gray",
        on: "#2C9AF4",
        on1: "purple",
        on2: "purple"
      }
    };
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
